if (!customElements.get('sakura-corporate-gifting')) {
  customElements.define('sakura-corporate-gifting', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      document.documentElement.classList.add('sakura-corporate-theme');
      this.promotedNavigationItems = [];
      this.promotedNavigationSet = new WeakSet();
      this.navigationObservers = [];
      this.promoteCorporateNavigation();
      document.querySelectorAll('.js-sticky-header, #menuDrawer, .js-menu-drawer').forEach((root) => {
        const observer = new MutationObserver(() => this.promoteCorporateNavigation());
        observer.observe(root, { childList: true, subtree: true });
        this.navigationObservers.push(observer);
      });
      this.dialog = this.querySelector('[data-corporate-finder]');
      this.form = this.querySelector('[data-corporate-finder-form]');
      this.questions = Array.from(this.querySelectorAll('[data-corporate-question]'));
      this.questionnaire = this.querySelector('.sakura-corporate__finder-questionnaire');
      this.currentQuestion = 0;
      this.progress = this.querySelector('[data-corporate-progress]');
      this.progressWrap = this.querySelector('[data-corporate-progress-wrap]');
      this.progressText = this.querySelector('[data-corporate-progress-text]');
      this.navigation = this.querySelector('[data-corporate-navigation]');
      this.previousButton = this.querySelector('[data-corporate-previous]');
      this.nextButton = this.querySelector('[data-corporate-next]');
      this.reviewButton = this.querySelector('[data-corporate-review]');
      this.result = this.querySelector('[data-corporate-finder-result]');
      this.error = this.querySelector('[data-corporate-finder-error]');
      this.summary = this.querySelector('[data-corporate-brief-summary]');
      this.copyStatus = this.querySelector('[data-corporate-copy-status]');
      this.contactStep = this.querySelector('[data-corporate-contact-step]');
      this.contactHeading = this.querySelector('[data-corporate-contact-heading]');
      this.continueToContact = this.querySelector('[data-corporate-continue-to-contact]');
      this.entryButton = this.querySelector('[data-corporate-entry-continue]');
      this.entryError = this.querySelector('[data-corporate-entry-error]');
      this.previouslyFocused = null;

      this.querySelectorAll('[data-corporate-finder-open]').forEach((control) => {
        control.addEventListener('click', (event) => {
          event.preventDefault();
          this.openFinder(control);
        });
      });
      this.querySelectorAll('[data-corporate-finder-close]').forEach((control) => control.addEventListener('click', () => this.closeFinder()));
      if (this.entryButton) this.entryButton.addEventListener('click', () => this.continueFromEntry());
      this.querySelectorAll('input[name^="corporate-entry-quantity-"]').forEach((choice) => {
        choice.addEventListener('input', () => { if (this.entryError) this.entryError.hidden = true; });
      });
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.closeFinder(); });
      this.dialog.addEventListener('keydown', (event) => this.handleDialogKeydown(event));
      this.form.addEventListener('submit', (event) => this.reviewBrief(event));
      this.form.addEventListener('input', () => this.clearResult());
      this.nextButton.addEventListener('click', () => this.nextQuestion());
      this.previousButton.addEventListener('click', () => this.previousQuestion());
      this.querySelector('[data-corporate-edit-answers]').addEventListener('click', () => this.showQuestion(this.questions.length - 1, true));
      this.querySelector('[data-corporate-copy-brief]').addEventListener('click', () => this.copyBrief());
      this.continueToContact.addEventListener('click', () => this.showContactStep());
      this.querySelectorAll('[data-corporate-contact-back]').forEach((control) => control.addEventListener('click', () => this.showReviewFromContact()));
      this.showQuestion(0, false);
      const params = new URLSearchParams(window.location.search);
      if (params.get('quote') === '1') this.openFinder(null, 0);
    }

    disconnectedCallback() {
      document.documentElement.classList.remove('sakura-corporate-dialog-open');
      this.navigationObservers?.forEach((observer) => observer.disconnect());
      this.restoreCorporateNavigation();
      if (!document.querySelector('sakura-corporate-gifting')) {
        document.documentElement.classList.remove('sakura-corporate-theme');
      }
    }

    promoteCorporateNavigation() {
      const roots = document.querySelectorAll('.js-sticky-header .js-header-navigation, #menuDrawer, .js-menu-drawer');
      roots.forEach((root) => {
        Array.from(root.querySelectorAll('a, button')).forEach((control) => {
          const label = control.textContent.replace(/\s+/g, ' ').trim();
          if (label.toLowerCase() !== 'Corporate Gifting'.toLowerCase()) return;
          const item = control.closest('li');
          const parent = item?.parentElement;
          if (!item || !parent || !root.contains(parent) || parent.firstElementChild === item) return;
          if (!this.promotedNavigationSet.has(item)) {
            this.promotedNavigationSet.add(item);
            this.promotedNavigationItems.push({ item, parent, nextSibling: item.nextSibling });
          }
          parent.insertBefore(item, parent.firstElementChild);
        });
      });
    }

    restoreCorporateNavigation() {
      [...(this.promotedNavigationItems || [])].reverse().forEach(({ item, parent, nextSibling }) => {
        if (!item.isConnected || !parent.isConnected) return;
        if (nextSibling && nextSibling.parentElement === parent) parent.insertBefore(item, nextSibling);
        else parent.appendChild(item);
      });
      this.promotedNavigationItems = [];
      this.promotedNavigationSet = new WeakSet();
    }

    continueFromEntry() {
      const selected = this.querySelector('input[name^="corporate-entry-quantity-"]:checked');
      if (!selected) {
        this.entryError.hidden = false;
        this.entryError.focus();
        return;
      }
      const quantity = Array.from(this.form.querySelectorAll('input[name^="finder-quantity-"]')).find((choice) => choice.value === selected.value);
      if (quantity) {
        quantity.checked = true;
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
      }
      this.openFinder(this.entryButton, 1);
    }

    openFinder(opener, startIndex = 0) {
      this.previouslyFocused = opener || document.activeElement;
      this.dialog.hidden = false;
      this.dialog.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('sakura-corporate-dialog-open');
      this.querySelectorAll(':scope > section').forEach((section) => {
        section.inert = true;
        section.setAttribute('aria-hidden', 'true');
      });
      this.form.hidden = false;
      this.contactStep.hidden = true;
      this.showQuestion(startIndex, false);
      this.focusCurrentQuestion();
    }

    closeFinder() {
      this.dialog.hidden = true;
      this.dialog.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sakura-corporate-dialog-open');
      this.querySelectorAll(':scope > section').forEach((section) => {
        section.inert = false;
        section.removeAttribute('aria-hidden');
      });
      if (this.previouslyFocused && document.contains(this.previouslyFocused)) this.previouslyFocused.focus();
    }

    handleDialogKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeFinder();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(this.dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], select:not([disabled]), textarea:not([disabled])')).filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    focusCurrentQuestion() {
      const target = this.questions[this.currentQuestion]?.querySelector('input, select, textarea');
      if (target) target.focus();
    }

    showQuestion(index, shouldFocus = true) {
      this.form.hidden = false;
      this.contactStep.hidden = true;
      this.currentQuestion = Math.max(0, Math.min(index, this.questions.length - 1));
      this.questions.forEach((question, questionIndex) => {
        question.hidden = questionIndex !== this.currentQuestion;
      });
      this.result.hidden = true;
      this.questionnaire.hidden = false;
      this.progressWrap.hidden = false;
      this.navigation.hidden = false;
      this.progress.value = this.currentQuestion + 1;
      this.progressText.textContent = `Question ${this.currentQuestion + 1} of ${this.questions.length}`;
      this.previousButton.hidden = this.currentQuestion === 0;
      this.nextButton.hidden = this.currentQuestion === this.questions.length - 1;
      this.reviewButton.hidden = this.currentQuestion !== this.questions.length - 1;
      this.error.hidden = true;
      if (shouldFocus) this.focusCurrentQuestion();
    }

    validateQuestion(index = this.currentQuestion, report = true) {
      const question = this.questions[index];
      if (!question) return true;
      if (question.hasAttribute('data-customisation-question') && !question.querySelector('input:checked')) {
        if (report) {
          this.error.hidden = false;
          question.querySelector('input')?.focus();
        }
        return false;
      }
      const invalid = Array.from(question.querySelectorAll('input, select, textarea')).find((field) => !field.checkValidity());
      if (invalid) {
        if (report) {
          this.error.hidden = false;
          invalid.reportValidity();
          invalid.focus();
        }
        return false;
      }
      this.error.hidden = true;
      return true;
    }

    nextQuestion() {
      if (!this.validateQuestion()) return;
      this.showQuestion(this.currentQuestion + 1, true);
    }

    previousQuestion() {
      this.showQuestion(this.currentQuestion - 1, true);
    }

    field(prefix) {
      return this.form.querySelector(`[name^="finder-${prefix}-"]`);
    }

    fieldValue(prefix) {
      const field = this.field(prefix);
      return field ? field.value.trim() : '';
    }

    selectedValue(prefix) {
      const selected = this.form.querySelector(`input[name^="finder-${prefix}-"]:checked`);
      return selected ? selected.value : '';
    }

    selectedValues(prefix) {
      return Array.from(this.form.querySelectorAll(`input[name^="finder-${prefix}-"]:checked`)).map((field) => field.value);
    }

    buildBrief() {
      const lines = [
        `Approximate quantity: ${this.selectedValue('quantity')}`,
        `Preferred gift box: ${this.fieldValue('box')}`,
        `Customisation focus: ${this.selectedValues('customisation').join(', ')}`,
        `Set plan: ${this.selectedValue('sets')}`,
        `Delivery plan: ${this.selectedValue('delivery')}`,
        `Required arrival date: ${this.fieldValue('arrival')}`,
        `Timing flexibility: ${this.fieldValue('timing')}`,
      ];
      const notes = this.fieldValue('notes');
      if (notes) lines.push(`Additional context: ${notes}`);
      return lines.join('\n');
    }

    reviewBrief(event) {
      event.preventDefault();
      const invalidIndex = this.questions.findIndex((question, index) => !this.validateQuestion(index, false));
      if (invalidIndex !== -1) {
        this.showQuestion(invalidIndex, false);
        this.validateQuestion(invalidIndex, true);
        return;
      }

      this.error.hidden = true;
      this.summary.value = this.buildBrief();
      this.questions.forEach((question) => { question.hidden = true; });
      this.questionnaire.hidden = true;
      this.progressWrap.hidden = true;
      this.navigation.hidden = true;
      this.result.hidden = false;
      this.copyStatus.textContent = '';
      this.result.focus();
    }

    populateEnquiryForm() {
      const quantity = this.querySelector('[data-corporate-quote-quantity]');
      const delivery = this.querySelector('[data-corporate-quote-delivery]');
      const arrival = this.querySelector('[data-corporate-quote-arrival]');
      const brief = this.querySelector('[data-corporate-quote-brief]');
      if (quantity) quantity.value = this.selectedValue('quantity');
      if (delivery) delivery.value = this.selectedValue('delivery');
      if (arrival) arrival.value = this.fieldValue('arrival');
      if (brief) brief.value = this.summary.value || this.buildBrief();
    }

    showContactStep() {
      this.populateEnquiryForm();
      this.form.hidden = true;
      this.contactStep.hidden = false;
      this.contactHeading?.focus();
    }

    showReviewFromContact() {
      this.contactStep.hidden = true;
      this.form.hidden = false;
      this.result.hidden = false;
      this.questionnaire.hidden = true;
      this.progressWrap.hidden = true;
      this.navigation.hidden = true;
      this.result.focus();
    }

    clearResult() {
      this.error.hidden = true;
      this.result.hidden = true;
      this.copyStatus.textContent = '';
    }

    async copyBrief() {
      const brief = this.summary.value;
      if (!brief) return;
      try {
        await navigator.clipboard.writeText(brief);
        this.copyStatus.textContent = 'Brief copied.';
      } catch (error) {
        this.summary.focus();
        this.summary.select();
        const copied = document.execCommand('copy');
        this.copyStatus.textContent = copied ? 'Brief copied.' : 'Select the brief and copy it manually.';
      }
    }
  });
}
